import { invalidateFieldRecords } from "app/utils/relay";

import type { IEnvironment, RecordSourceSelectorProxy } from "relay-runtime";

/**
 * Marks every cached `policies` list stale after collection membership
 * changes, so filtered and sorted pages refetch instead of replaying the store.
 */
export function invalidatePolicyLists(
  environment: IEnvironment,
  store: RecordSourceSelectorProxy,
) {
  invalidateFieldRecords(environment, "policies", "client:root", store);
}
